import { getCurrentProcessSteps } from '../../utils/stepMachine';

export const getCompletedSteps = state => {
  const currentStep = state.account.registrationStep;
  const steps = getCurrentProcessSteps(currentStep);
  const index = steps.indexOf(currentStep);

  return index > 0 ? steps.slice(0, index) : [];
};

export const getAccountDetails = state => {
  const {
    firstname,
    lastname,
    email,
    address,
    addressLine1,
    addressLine2,
    address_postal_code,
    address_locality,
    address_state,
    address_country,
    phoneNumber,
    newPhoneNumber,
    licenceExpirationTime,
    licenceLocation,
    licenceNumber,
    licenceObtainingTime,
    creditCard,
    avatar
  } = state.account;
  return {
    firstname,
    lastname,
    email,
    address,
    addressLine1,
    addressLine2,
    address_postal_code,
    address_locality,
    address_state,
    address_country,
    phoneNumber,
    newPhoneNumber,
    licenceExpirationTime,
    licenceLocation,
    licenceNumber,
    licenceObtainingTime,
    creditCard,
    avatar
  };
};
